import { LogoInfraAssistantColored } from "components/icons/generated";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

const AiChatAvatarAnimated = () => {
  return <Icon src={LogoInfraAssistantColored} size="large" noShrink className={styles.avatar} />;
};

export default AiChatAvatarAnimated;
